import moment from 'moment'


const boolCellStyle = function(params) {
  if (params.value === 'T') {
    return { backgroundColor: '#88af2c' }
  } else if (params.value === 'F') {
    return { backgroundColor: '#e20000', color: '#fff' }
  } else {
    
  }
}

export default {
  name: 'Kiosk Crud',
  contentTypes: [
    // menuairlines
    {
      name: 'MenuAirlines',
      label: 'Kiosk Buttons', 
      idKey: 'MenuAirlineId',
      menu: true,
      rowHeight: 70,
      permissions: ['add', 'edit', 'delete', 'saveOrder'],
      endpoints: {
        read: 'kioskManage/menuairlines/get',
        byId: 'kioskManage/menuairlines/get/menuairlineid',
        post: '',
        patch: '',
        delete: 'kioskManage/menuairline/delete/id',
      },
      fields: [
        {
          headerName: 'MenuAirlineId',
          field: 'MenuAirlineId',
          type: 'text',
          hide: true,
          
        },
        {
          headerName: 'Group Name',
          field: 'AirlineName',
          type: 'text',
          pinned: true,
          rowDrag: true
        },
        {
          headerName: 'Group Code',
          field: 'AirlineIcaoCode',
          type: 'text',
        },
        {
          headerName: 'Logo',
          field: 'AirlineLogo',
          type: 'text',
          cellRenderer: 'logoRenderer',
          cellClass: 'bg-dark center',
          width: 300,
        },
      ],
    },

    {
      name: 'Handlers',
      label: 'Handlers',
      idKey: 'HandlerId',
      menu: false,
      permissions: ['add', 'edit', 'delete'],
      endpoints: {
        readType: 'post',
        read: 'kioskManage/handlers/get',
        byId: '',
        post: '',
        patch: '',
        delete: '',
      },
      fields: [
        {
          headerName: 'HandlerId',
          field: 'HandlerId',
          type: 'text',
          pinned: true,
        },
        {
          headerName: 'HandlerCode',
          field: 'HandlerCode',
          type: 'text',
        },
        {
          headerName: 'LocationAreaId',
          field: 'LocationAreaId',
          type: 'text',
        },
        {
          headerName: 'SchemaName',
          field: 'SchemaName',
          type: 'text',
        },
        {
          headerName: 'EncryptedPassword',
          field: 'EncryptedPassword',
          type: 'text',
        },
        {
          headerName: 'DbAlias',
          field: 'DbAlias',
          type: 'text',
        },
      ],
    },

    {
      name: 'LocationAreas',
      label: 'Location Areas',
      idKey: 'LocationAreaId',
      menu: false,
      permissions: ['add', 'edit', 'delete'],
      endpoints: {
        readType: 'post',
        read: 'kioskManage/locationareas/get',
        byId: '',
        post: '',
        patch: '',
        delete: '',
      },
      fields: [
        {
          headerName: 'LocationAreaId',
          field: 'LocationAreaId',
          type: 'text',
          pinned: true,
        },
        {
          headerName: 'AirportCode',
          field: 'AirportCode',
          type: 'text',
        },
        {
          headerName: 'TerminalCode',
          field: 'TerminalCode',
          type: 'text',
        },
        {
          headerName: 'TerminalArea',
          field: 'TerminalArea',
          type: 'text',
        },
      ],
    },

    {
      name: 'AirlineGroup',
      label: 'Kiosk Locations',
      idKey: 'MenuAirlineGroupId',
      menu: true,
      permissions: ['add', 'edit', 'delete'],
      dependencies: ['LocationAreas'],
      endpoints: {
        readType: 'post',
        read: 'kioskManage/menuairlinegroups/get',
        byId: 'kioskManage/menuairlinegroups/get/menuairlinegroupid',
        post: 'kioskManage/menuairlinegroup/add',
        patch: 'kioskManage/menuairlinegroup/update',
        delete: 'kioskManage/menuairlinegroup/delete/id',
      },
      fields: [
        {
          headerName: 'MenuAirlineGroupId',
          field: 'MenuAirlineGroupId',
          type: 'text',
          hide: true,
        },
        {
          headerName: 'Group',
          field: 'AirlineIcaoCode',
          type: 'text',
          width: 120,
          pinned: true,
        },
        {
          headerName: 'Location',
          field: 'LocationAreaId',
          type: 'text',
          width: 400,
          cellRenderer: (node) => {
            console.log(node.data)
            return `Airport: ${node.data.Location.AirportCode} | Terminal: ${node.data.Location.TerminalCode} | Terminal Area: ${node.data.Location.TerminalArea}`
          },
        },
        {
          headerName: 'Handler',
          field: 'HandlerCode',
          type: 'text',
        },
      ],
    },

    {
      name: 'Airlines',
      label: 'Airlines',
      idKey: 'AirlineId',
      menu: true,
      permissions: ['add', 'edit', 'delete'],
      dependencies: ['AirlineGroup'],
      endpoints: {
        readType: 'post',
        read: '/kioskManage/airlines/get',
        byId: 'kioskManage/airlines/get/airlineid/',
        post: 'kioskManage/airline/add',
        patch: 'kioskManage/airline/update',
        delete: 'kioskManage/airline/delete/id/',
      },
      fields: [
        {
          headerName: 'AirlineId',
          field: 'AirlineId',
          type: 'text',
          hide: true,
        },
        {
          headerName: 'Airline',
          field: 'AirlineCode',
          type: 'text',
          pinned: true,
        },
        {
          headerName: 'Airline Group',
          field: 'AirlineGroupId',
          type: 'text',
          hide: true,
        },
        {
          headerName: 'Airline Group',
          field: 'AirlineGroup.AirlineIcaoCode',
        },
        {
          headerName: 'Check-In Enabled',
          field: 'CheckInEnabled',
          type: 'text',
          cellRenderer: 'boolRenderer',
          cellStyle: boolCellStyle,
        },
        {
          headerName: 'BTP Printing Enabled',
          field: 'BagTagPrintingEnabled',
          type: 'text',
          cellRenderer: 'boolRenderer',
          cellStyle: boolCellStyle,
        },
        {
          headerName: 'Max Group Size',
          field: 'MaxGroupSize',
          type: 'text',
        },
      ],
    },

    {
      name: 'Kiosks',
      label: 'Kiosks Database',
      idKey: 'KioskName',
      menu: true,
      permissions: ['edit', 'delete'],
      endpoints: {
        read: 'kioskManage/kiosks/get',
        byId: 'kioskManage/kiosks/getbykioskname',
        patch: 'kioskManage/kiosks/update',
        delete: 'kioskManage/kiosk/delete',
      },
      fields: [
        {
          headerName: 'Name',
          field: 'KioskName',
          type: 'text',
          pinned: true,
        },
        {
          headerName: 'Airport',
          field: 'AirportCode',
          type: 'text',
          width: 100,
        },
        {
          headerName: 'Terminal',
          field: 'TerminalCode',
          type: 'text',
          width: 100,
        },
        {
          headerName: 'Area',
          field: 'TerminalArea',
          type: 'text',
          width: 100,
        },
        {
          headerName: 'Enabled',
          field: 'KioskEnabled',
          type: 'text',
          cellRenderer: 'boolRenderer',
          cellStyle: boolCellStyle,
        },
        {
          headerName: 'Commission Date',
          field: 'KioskCommissionDate',
          type: 'text',
          cellRenderer: (data) => {
            return moment(data.value).format('HH:mm DDMMMYY')
          },
        },
      ],
    },

    {
      name: 'KioskAirlines',
      label: 'Kiosks Airlines',
      idKey: 'AirlineId',
      permissions: ['add', 'edit', 'delete'],
      endpoints: {
        readType: 'post',
        read: '/kioskManage/getairlines',
        byId: 'kioskManage/getbykioskname',
        post: 'kioskManage/addairline',
        patch: 'kioskManage/updateairline',
        delete: 'deleteairline/id/',
      },
      fields: [
        {
          headerName: 'AirlineId',
          field: 'AirlineId',
          type: 'text',
          pinned: true,
        },
        {
          headerName: 'AirlineCode',
          field: 'AirlineCode',
          type: 'text',
          width: 100,
        },
        {
          headerName: 'AirlineGroupId',
          field: 'AirlineGroupId',
          type: 'text',
          width: 100,
        },
        {
          headerName: 'CheckInEnabled',
          field: 'CheckInEnabled',
          type: 'text',
          width: 100,
        },
        {
          headerName: 'BagTagPrintingEnabled',
          field: 'BagTagPrintingEnabled',
          type: 'text',
        },
        {
          headerName: 'MaxGroupSize',
          field: 'MaxGroupSize',
          type: 'text',
        },
      ],
    },

    {
      name: 'OperatingHours',
      label: 'Operating Hours',
      idKey: 'OperatingTimeId',
      menu: true,
      permissions: ['add', 'edit', 'delete'],
      endpoints: {
        read: 'kioskManage/optimes/get',
        byId: 'kioskManage/optimes/get/operatingtimeid',
        post: 'kioskManage/optime/add',
        patch: 'kioskManage/optime/update',
        delete: 'kioskManage/optime/delete/id',
      },
      componentOverride: 'timeline',
      fields: [
        {
          headerName: 'OperatingTimeId',
          field: 'OperatingTimeId',
          type: 'text',
          hide: true,
        },
        {
          headerName: 'KioskName',
          field: 'KioskName',
          type: 'text',
          pinned: true,
          
        },
        {
          headerName: 'DayOfWeek',
          field: 'DayOfWeek',
          type: 'text',
          cellRenderer:  'dayOfWeek'
         
        },
        {
          headerName: 'EventTime',
          field: 'EventTime',
          type: 'text',
          cellRenderer: 'hhmmRenderer'
         
        },
        {
          headerName: 'KioskState',
          field: 'KioskState',
          type: 'text',
        },
      ],
    },


    {
      name: 'ApisRoutes',
      label: 'API Rules',
      idKey: 'ApisRouteId',
      menu: true,
      permissions: ['add', 'edit', 'delete'],
      endpoints: {
        read: 'kioskManage/apisroutes/get',
        byId: 'kioskManage/apisroutes/get/id',
        post: 'kioskManage/apisroute/add',
        patch: 'kioskManage/apisroute/update',
        delete: 'kioskManage/apisroute/delete/id',
      },
      
      fields: [
        {
          headerName: 'ApisRouteId',
          field: 'ApisRouteId',
          type: 'text',
          hide: true,
        },
        {
          headerName: 'DESTN/COUNTRY',
          field: 'DestinationCountry',
          type: 'text',
          sort: 'asc'
          
        },
        {
          headerName: 'DOCUMENT TYPE',
          field: 'DocumentType',
          type: 'text',
         
        },
        {
          headerName: 'Nationality',
          field: 'Nationality',
          type: 'text',
         
        },
        {
          headerName: 'Expiry Date Check Days',
          field: 'ExpiryDateCheckDays',
          type: 'text',
        },
        {
          headerName: 'Add Warning',
          field: 'PaxWarning',
          type: 'text',
          cellStyle: boolCellStyle,
          cellRenderer: 'boolRenderer',
        },
        {
          headerName: 'Description',
          field: 'Description',
          type: 'text',
          hide: true
        },
      ],
    },
  ],
}
